export default __webpack_public_path__ + "static/media/AronAndreea.714c834d.jpg";